import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SalesAgentPerformance = () => {

  const [stats, setStats] = useState("");
  const [loading, setLoading] = useState(true);
  const [agentPerformance, setAgentPerformance] = useState([]);

  const user = JSON.parse(localStorage.getItem('user'));
  const email = user.email;


  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(`https://citi-mobile-app.onrender.com/salessupervisors/transaction/${email}`);
        setStats(response.data);
      } catch (error) {
        console.error('Error fetching transaction stats:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);


  useEffect(() => {
    const fetchAgentPerformance = async () => {
      try {
        const response = await axios.get(`https://citi-mobile-app.onrender.com/salessupervisors/transaction-details`);
        setAgentPerformance(response.data.data);
      } catch (error) {
        console.error('Error fetching agent performance:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAgentPerformance();
  }, [email]);


  

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="w-16 h-16 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="p-4 max-sm:p-0 ml-60 mt-20 max-sm:ml-0 max-sm:w-screen">
      <div className="flex flex-wrap justify-between mb-6">
       <div className="bg-white shadow-md rounded-lg p-4 w-44">
        <p className="text-gray-600">Total Order Raised</p>
        <h2 className="text-3xl font-bold">{stats.totalOrdersRaised}</h2>
      </div>
      <div className="bg-white shadow-md rounded-lg p-4 w-44">
        <p className="text-gray-600">Delivered Orders</p>
        <h2 className="text-3xl font-bold">{stats.deliveredOrders}</h2>
      </div>
      <div className="bg-white shadow-md rounded-lg p-4 w-44">
        <p className="text-gray-600">Total Sales Today</p>
        <h2 className="text-3xl font-bold">{stats.salesToday}</h2>
      </div>
      <div className="bg-white shadow-md rounded-lg p-4 w-44">
        <p className="text-gray-600">Pending Orders</p>
        <h2 className="text-3xl font-bold">{stats.pendingOrders}</h2>
      </div>

      </div>


    {/* Sales Agent Performance Table */}
    
      <div className="overflow-x-auto bg-white p-3 rounded-md">
      <h3 className="text-lg font-semibold mb-4">Sales Agent Performance Table</h3>
        <table className="min-w-full bg-white rounded-lg shadow-md">
          <thead>
            <tr className="bg-gray-200 text-left text-gray-600 uppercase text-sm leading-normal">
              <th className="py-3 px-6">No</th>
              <th className="py-3 px-6">Agent Name</th>
              <th className="py-3 px-6">Total Sales Raised</th>
              <th className="py-3 px-6">Delivered Orders</th>
              <th className="py-3 px-6">Pending Orders</th>
              <th className="py-3 px-6">Total Amount</th>
            </tr>
          </thead>
          <tbody className="text-gray-600 text-sm font-light">
            {agentPerformance.map((agent, index) => (
              <tr key={index} className="border-b border-gray-200 hover:bg-gray-100">
                <td className="py-3 px-6">{index + 1}</td>
                <td className="py-3 px-6">{agent.firstName} {agent.lastName}</td>
                <td className="py-3 px-6">{agent.totalSalesRaised}</td>
                <td className="py-3 px-6">{agent.deliveredOrders}</td>
                <td className="py-3 px-6">{agent.pendingOrders}</td>
                <td className="py-3 px-6">₦{agent.totalAmount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SalesAgentPerformance;
